import { useState, useCallback } from 'react';
import { WORD_LENGTH } from '../game-logic/config';
import { playTileRevealSound } from '../utils/sounds';

export const useGameInteractions = (
  gameState,
  onStateChange,
  onWordFound,
  onCheckWord,
  onSwap
) => {
  const [isCheckMode, setIsCheckMode] = useState(false);
  const [selectedTiles, setSelectedTiles] = useState([]);
  const [showConfirmCheck, setShowConfirmCheck] = useState(false);

  const handleToggleCheckMode = useCallback(() => {
    if (isCheckMode) {
      setIsCheckMode(false);
      setSelectedTiles([]);
    } else {
      setIsCheckMode(true);
      setSelectedTiles([]);
    }
  }, [isCheckMode]);

  const handleTileClick = useCallback((row, col) => {
    if (!isCheckMode) return;

    // Play reveal sound on each tile selection in check mode
    playTileRevealSound();

    const newSelectedTiles = [...selectedTiles];
    const selectedIndex = newSelectedTiles.findIndex(t => t.row === row && t.col === col);

    if (selectedIndex > -1) {
      newSelectedTiles.splice(selectedIndex, 1);
    } else if (newSelectedTiles.length < WORD_LENGTH) {
      newSelectedTiles.push({ row, col });
    }
    
    setSelectedTiles(newSelectedTiles);

    if (newSelectedTiles.length === WORD_LENGTH) {
      setShowConfirmCheck(true);
    }
  }, [isCheckMode, selectedTiles]);
  
  const handleConfirmCheckWord = useCallback(() => {
    if (selectedTiles.length === WORD_LENGTH) {
      onCheckWord(selectedTiles);
    }
    setShowConfirmCheck(false);
    setIsCheckMode(false);
    setSelectedTiles([]);
  }, [selectedTiles, onCheckWord]);

  const handleCancelCheckWord = useCallback(() => {
    setShowConfirmCheck(false);
    setSelectedTiles([]);
  }, []);

  return {
    isCheckMode,
    selectedTiles,
    showConfirmCheck,
    handleTileClick,
    handleToggleCheckMode,
    handleConfirmCheckWord,
    handleCancelCheckWord,
  };
}; 